import { ActivityLogs } from "../../modules/custom/activitylogs/activitylogs";

const UserLogs: React.FC = () => {


    return (
        <div  className='card mb-5 mb-xl-5'>
            <ActivityLogs></ActivityLogs>
        </div>
    )
  }
  
  export {UserLogs}